import { useIntl, defineMessages } from 'react-intl'
import { useQuery, gql } from '@apollo/client'

import { Select } from 'components/v2/Select'
import { Input } from 'components/Input'

const GET_VEHICLE_TEMPLATES_AUTOCOMPLETE = gql`
  query GetVehicleTemplatesAutocomplete($capacity: Int!, $type: VehicleType!) {
    vehicleTemplatesAutocomplete(input: { capacity: $capacity, type: $type }) {
      id
      name
    }
  }
`

const messages = defineMessages({
  selectTemplate: {
    id: 'vehicleTemplates.select.placeholder',
    defaultMessage: 'Select a template'
  },
  requirements: {
    id: 'vehicleTemplates.select.requirements',
    defaultMessage: 'Select a type and a capacity'
  },
  noResult: {
    id: 'vehicleTemplates.select.noResult',
    defaultMessage: 'No templates available'
  }
})

const SelectByTypeAndCapacity = ({ capacity, type, ...props }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  const { data } = useQuery(GET_VEHICLE_TEMPLATES_AUTOCOMPLETE, {
    skip: !capacity || !type,
    variables: {
      capacity,
      type: type.toLowerCase()
    }
  })

  if (data && data.vehicleTemplatesAutocomplete && data.vehicleTemplatesAutocomplete.length === 0) {
    return <Input {...props} label={props.label} value={intl.formatMessage(messages.noResult)} readOnly />
  }

  const getVehicleTemplates = (): TSFixMe => {
    if (data && data.vehicleTemplatesAutocomplete) {
      return data.vehicleTemplatesAutocomplete
    }

    return []
  }

  return (
    <Select getTagLabel={({ name }: TSFixMe): TSFixMe => name} {...props}>
      <option value="">{intl.formatMessage(messages.selectTemplate)}</option>

      {getVehicleTemplates().map((template: TSFixMe): TSFixMe => {
        return (
          <option key={template.id} value={template.id}>
            {template.name}
          </option>
        )
      })}
    </Select>
  )
}

export const SelectVehicleTemplate = ({ capacity, type, ...props }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  if (!capacity || !type) {
    return <Input {...props} label={props.label} value={intl.formatMessage(messages.requirements)} readOnly />
  }

  return <SelectByTypeAndCapacity capacity={capacity} type={type} {...props} />
}
